import type {BasicNamedLabeledIdentified} from 'typings/portaro.be.types';
import propFilter from '../commons/filters/prop';
import inlineFilter from '../commons/filters/inline';
import charactersFilter from '../commons/filters/characters';
import locFilter from '../commons/filters/loc';
import strParamsFilter from '../commons/filters/str-params';
import recordDetailPathFilter from '../commons/filters/record-detail-path.filter';

// extends BasicNamedLabeledIdentified<any> is necessary in order to not throw error when used
// because TS can not infer T from returned function params
// if it needs to be used with other props, update extend statement to include wanted props
export function prop<T extends BasicNamedLabeledIdentified<any>>(propertyName: keyof T): (_: T[]) => Array<T[keyof T]> {
    return (array: T[]) => propFilter()(array, propertyName);
}

export function inline(delimiter?: string, prefix?: string, suffix?: string): (_: any[]) => string {
    return (array: any[]) => inlineFilter()(array, delimiter, prefix, suffix);
}

export function characters(maxChars: number, canBreakOnWord = false): (_: string) => string {
    return (input: string) => charactersFilter()(input, maxChars, canBreakOnWord);
}

export function loc(): (_: any) => string | null {
    return (object: any) => locFilter()(object);
}

export function strParams(...params: string[]): (_: string) => string {
    return (text: string) => strParamsFilter()(text, ...params);
}

export function recordDetailPath(): (_: string) => string {
    return (record) => recordDetailPathFilter()(record);
}


